import * as React from 'react';

import * as ramda from 'ramda';

import {convertToObj} from 'nutshell-core/filter';
import * as Schema from 'nutshell-core/schema';
import type {CoreEntityType, FilterObject} from 'nutshell-core/types';

import {getPrimaryFilters} from '../../entities/entities-constants';

import {FilterDrawer} from './filters/filter-drawer';

type Props = {
    entityType: CoreEntityType;
    activeFilters: FilterObject[];
    fields: Schema.FieldProperties[];
    isOpen: boolean;
    addFilters: (arg1: FilterObject) => any;
    updateFilter: (arg1: FilterObject, arg2: FilterObject) => any;
    removeFilters: (arg1: FilterObject[] | FilterObject) => any;
    shownColumns?: string[];
    updateShownColumns?: (arg1: string[], arg2: boolean) => void;
};

export function EntityListFilterDrawer(props: Props) {
    const handleFilterSubmit = (filter: FilterObject, field: Schema.FieldProperties) => {
        const existingAppliedFilter = ramda.find(
            (entry) => Object.keys(entry)[0] === field.name,
            props.activeFilters
        );

        if (existingAppliedFilter) {
            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined')
                // @ts-expect-error
                window.trackJs.console.info(
                    'User updated filter from:',
                    existingAppliedFilter,
                    'to',
                    filter
                );
            props.updateFilter(existingAppliedFilter, filter);
        } else {
            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined')
                // @ts-expect-error
                window.trackJs.console.info('User added filter:', filter);
            props.addFilters(filter);
        }
    };

    /**
     * Takes a filterKey (read: `owner`, `confidence`) and removes that
     * filter from the current set of filters.
     *
     * @param  {string} filterKey name of filter to remove
     * @return {void}
     */
    const handleFilterRemove = (filterKey: string) => {
        const filterToRemove = props.activeFilters.filter((filterObj) =>
            Object.prototype.hasOwnProperty.call(filterObj, filterKey)
        );
        // @ts-expect-error
        if (typeof window.trackJs !== 'undefined')
            // @ts-expect-error
            window.trackJs.console.info('User removed filter:', filterToRemove);
        props.removeFilters(convertToObj(filterToRemove));
    };

    return (
        <FilterDrawer
            activeFilters={props.activeFilters}
            // @ts-expect-error
            primaryFilters={getPrimaryFilters(props.entityType)}
            entityType={props.entityType}
            isOpen={props.isOpen}
            fields={props.fields}
            onSubmitFilter={handleFilterSubmit}
            onRemoveFilter={handleFilterRemove}
            shownColumns={props.shownColumns}
            updateShownColumns={props.updateShownColumns}
        />
    );
}
